/* eslint-disable @typescript-eslint/no-explicit-any */
import AT from '../../constants/action-types';
import { put, call, all } from 'redux-saga/effects';
import {
  fetchBooths,
  fetchControlBoxes,
  fetchLocations,
  fetchQueues,
  fetchServiceProvider,
  fetchServices,
  fetchDisplays,
  fetchKiosks,
  fetchServiceProviderUsers,
  resetApiCache
} from '../../api';
import logger from '../../utils/logger';

function* putIfOk(actionName: any, response: any) {
  if (response.httpStatus === 200) {
    yield put({ type: actionName, ...response });
  }
}

const setEmptyItem = () => ({ data: { items: [] }, httpStatus: 200 });

export function* reloadProviderData(): any {
  resetApiCache();
  yield put({ type: AT.RELOAD_PROVIDER_DATA });
  try {
    const [
      serviceProvider,
      services,
      booths,
      displays,
      kiosks,
      queues,
      controlBoxes,
      locations,
      users
    ] = yield all([
      call(fetchServiceProvider),
      call(fetchServices),
      call(fetchBooths),
      call(fetchDisplays),
      call(fetchKiosks),
      call(fetchQueues),
      call(fetchControlBoxes),
      call(fetchLocations),
      call(fetchServiceProviderUsers)
    ]);

    yield putIfOk(AT.FETCH_SERVICE_PROVIDER_DONE, serviceProvider);
    yield putIfOk(AT.FETCH_SERVICES_DONE, services);
    yield putIfOk(AT.FETCH_BOOTHS_DONE, booths);
    yield putIfOk(AT.FETCH_DISPLAYS_DONE, displays);
    yield putIfOk(AT.FETCH_KIOSKS_DONE, kiosks);
    yield putIfOk(AT.FETCH_QUEUES_DONE, queues);
    yield putIfOk(AT.FETCH_CONTROL_BOXES_DONE, controlBoxes);
    yield putIfOk(AT.FETCH_LOCATIONS_DONE, locations);
    yield putIfOk(AT.FETCH_SERVICE_PROVIDER_USERS_DONE, users);

    yield put({ type: AT.APP_INIT_COMPLETED, error: false, adminInit: false });

    return {
      serviceProvider,
      services,
      booths,
      queues,
      controlBoxes,
      locations
    };
  } catch (e) {
    // A failed reload must still let the app render, or it hangs on the
    // "loading" splash with nothing on screen and nothing in the console.
    // Returning empty collections rather than rethrowing also keeps one dead
    // endpoint from tearing down the whole root saga, which is what a missing
    // route used to do here.
    logger.exception('Failed to load provider data', e);
    yield put({ type: AT.APP_INIT_COMPLETED, error: true, adminInit: false });
    return {
      serviceProvider: setEmptyItem(),
      services: setEmptyItem(),
      booths: setEmptyItem(),
      queues: setEmptyItem(),
      controlBoxes: setEmptyItem(),
      locations: setEmptyItem()
    };
  }
}
